export default __webpack_public_path__ + "static/media/blood-pressure-icon.4da184de.svg";